/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  id: number;
  name: string;
  developer: {
    id: number;
    name: string;
  };
  apps: {
    id: number;
    appGroup: {
      id: number;
      name: string;
    };
    trackingVendor: {
      id: number;
      name: string;
    };
    os: string;
    appId: string;
    regexpCampaign?: string;
    regexpPubTwitter?: string;
  }[];
  createdAt: string;
  updatedAt: string;
};

export class Api {
  public static index(developerId: number) {
    return request.get<IndexResponse[]>(
      `/developers/${developerId}/app_groups`
    );
  }
}
